import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Play with the different parameters to observe their effect on frequency response. Click on “play sound” and move the orange disc to listen to the effect of the different directivities.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0416/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
